<template>
  <div style="height: 100%">
    <Teleport to="body">
      <transition name="fade">
        <ItemAllergenModal
          v-if="ItemAllergenModalIsOpen"
          @closeModal="toggleItemAllergenModal"
          @addToCart="handleAddToCart"
        />
      </transition>
    </Teleport>
    <div
      v-if="item.type == 'marketing'"
      :style="{
        background: 'url(' + item.image + ') no-repeat center center / cover',
      }"
      class="marketing"
    ></div>
    <div style="height: 100%; display: flex; flex-direction: column; overflow: hidden" v-else>
      <div
        v-if="checkIfImageIsVisible"
        class="itemImageWrapper hidden"
        :class="{ flyToCart: flyToCardItemId == item.item_id }"
        tabindex="0"
        aria-label="Item image"
      >
        <img :src="item.image_urls.thumbnail" :alt="item.name" loading="lazy" />
      </div>
      <div v-if="checkIfImageIsVisible" class="itemImageWrapper" tabindex="0" aria-label="Item image">
        <img :src="item.image_urls.thumbnail" :alt="item.name" loading="lazy" ref="itemImageWrapper" />
      </div>
      <div class="itemInfo" tabindex="0">
        <h3 class="itemName" tabindex="0">{{ item.name }}</h3>
        <p class="itemDescription" tabindex="0">{{ item.short_desc }}</p>
        <div v-if="item.allergen_ids || item.class_ids" class="allergyIcons" tabIndex=0>
          <div v-for="(allergen, index) in getUniqueAllergyIcons()" :key="index" class="allergens">
            <p class="allergensNoIcon" v-if="!allergen.icon_url" aria-hidden="true">{{ allergen.display }}</p>
            <img v-if="allergen.icon_url" :src="allergen.icon_url" :alt="allergen.name" class="allergen-icon" />
            <br />
            <div class="tooltip" aria-hidden="true">
              {{ allergen.name }}
            </div>
          </div>
        </div>
        <div v-if="allergenIds || itemClassIds">
          <p
            v-if="(allergenIds && allergenIds.length > 0) || (itemClassIds && itemClassIds.length > 0)"
            class="error-message"
          >
            <svg
              width="13"
              height="13"
              viewBox="0 0 13 13"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-label="Filters"
            >
              <path
                d="M6.52539 12.7461C5.70898 12.7461 4.93945 12.5898 4.2168 12.2773C3.49805 11.9648 2.86328 11.5332 2.3125 10.9824C1.76172 10.4316 1.33008 9.79688 1.01758 9.07812C0.705078 8.35547 0.548828 7.58594 0.548828 6.76953C0.548828 5.95312 0.705078 5.18555 1.01758 4.4668C1.33008 3.74414 1.75977 3.10742 2.30664 2.55664C2.85742 2.00586 3.49219 1.57422 4.21094 1.26172C4.93359 0.949219 5.70312 0.792969 6.51953 0.792969C7.33594 0.792969 8.10547 0.949219 8.82812 1.26172C9.55078 1.57422 10.1875 2.00586 10.7383 2.55664C11.2891 3.10742 11.7207 3.74414 12.0332 4.4668C12.3457 5.18555 12.502 5.95312 12.502 6.76953C12.502 7.58594 12.3457 8.35547 12.0332 9.07812C11.7207 9.79688 11.2891 10.4316 10.7383 10.9824C10.1875 11.5332 9.55078 11.9648 8.82812 12.2773C8.10938 12.5898 7.3418 12.7461 6.52539 12.7461ZM6.52539 11.75C7.2168 11.75 7.86328 11.6211 8.46484 11.3633C9.06641 11.1055 9.5957 10.75 10.0527 10.2969C10.5098 9.83984 10.8652 9.31055 11.1191 8.70898C11.377 8.10742 11.5059 7.46094 11.5059 6.76953C11.5059 6.07812 11.377 5.43164 11.1191 4.83008C10.8613 4.22852 10.5039 3.69922 10.0469 3.24219C9.59375 2.78516 9.06445 2.42969 8.45898 2.17578C7.85742 1.91797 7.21094 1.78906 6.51953 1.78906C5.82812 1.78906 5.18164 1.91797 4.58008 2.17578C3.97852 2.42969 3.45117 2.78516 2.99805 3.24219C2.54492 3.69922 2.18945 4.22852 1.93164 4.83008C1.67773 5.43164 1.55078 6.07812 1.55078 6.76953C1.55078 7.46094 1.67773 8.10742 1.93164 8.70898C2.18945 9.31055 2.54492 9.83984 2.99805 10.2969C3.45508 10.75 3.98438 11.1055 4.58594 11.3633C5.1875 11.6211 5.83398 11.75 6.52539 11.75ZM6.51953 7.82422C6.21875 7.82422 6.06445 7.66992 6.05664 7.36133L5.98047 4.26172C5.97656 4.11328 6.02344 3.99023 6.12109 3.89258C6.22266 3.79492 6.35352 3.74609 6.51367 3.74609C6.66992 3.74609 6.79883 3.79688 6.90039 3.89844C7.00586 3.99609 7.05664 4.11914 7.05273 4.26758L6.96484 7.36133C6.96094 7.66992 6.8125 7.82422 6.51953 7.82422ZM6.51953 9.72852C6.34766 9.72852 6.19922 9.66992 6.07422 9.55273C5.94922 9.43164 5.88672 9.28711 5.88672 9.11914C5.88672 8.95117 5.94922 8.80859 6.07422 8.69141C6.19922 8.57031 6.34766 8.50977 6.51953 8.50977C6.69141 8.50977 6.83984 8.56836 6.96484 8.68555C7.08984 8.80273 7.15234 8.94727 7.15234 9.11914C7.15234 9.29102 7.08789 9.43555 6.95898 9.55273C6.83398 9.66992 6.6875 9.72852 6.51953 9.72852Z"
                fill="#E75743"
              />
            </svg>
            <span class="visually-hidden">Contains:</span>
            {{
              (allergenIds || [])
                .concat(itemClassIds || [])
                .map((item) =>
                  item.name
                    .split(' ')
                    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                    .join(' ')
                )
                .join(', ')
            }}
          </p>
        </div>

        <div v-if="branding?.display_options?.show_prices_on_menu !== false" class="priceWrapper">
          <div class="item-info" tabindex="0">
            <h3 v-if="checkIfPriceIsVisible" class="itemPrice" tabindex="0">
              {{ formatPrice(getTheLowestPrice(item.variants)) }}
            </h3>
            <p
              v-if="item.variants[0].min_calories && item.variants[item.variants.length - 1].max_calories"
              class="calorie"
              tabindex="0"
            >
              <span class="separator">·</span>
              <span v-if="item.variants[0].min_calories == item.variants[item.variants.length - 1].max_calories">
                {{ item.variants[0].min_calories }} cals
              </span>
              <span v-else>
                {{ item.variants[0].min_calories }} cals -
                {{ item.variants[item.variants.length - 1].max_calories }} cals
              </span>
            </p>
          </div>

          <div
            v-if="orderData && !getTotalQuantity(item.item_id).totalQuantity"
            @click.stop="getItemData(item, category, 'add', 'quickAdd')"
            class="quickAdd"
            :class="{ fillScreen: fillScreenItemId == item.item_id && fillScreenAnimation && windowWidth <= 500 }"
            ref="quickAddButton"
            tabindex="0"
            aria-label="Quick add button"
          >
            <div
              v-if="quickAddLoading && quickAddLoadingItemId == item.item_id"
              class="loader smallLoader"
              tabindex="0"
              :style="{ display: fillScreenItemId == item.item_id && fillScreenAnimation ? 'none' : 'block' }"
            ></div>
            <svg
              v-else
              xmlns="http://www.w3.org/2000/svg"
              width="6.033"
              height="6.033"
              viewBox="0 0 6.033 6.033"
              tabindex="0"
              :style="{ display: fillScreenItemId == item.item_id && fillScreenAnimation ? 'none' : 'block' }"
            >
              <path
                id="Path_19847"
                data-name="Path 19847"
                d="M218.614,145.6a.377.377,0,0,0-.377.377v2.262h-2.262a.377.377,0,0,0,0,.754h2.262v2.262a.377.377,0,0,0,.754,
                              0v-2.262h2.262a.377.377,0,0,0,0-.754h-2.262v-2.262A.377.377,0,0,0,218.614,145.6Z"
                transform="translate(-215.598 -145.6)"
              />
            </svg>
          </div>
          <div
            :style="{
              'border-color': qtyLoading ? 'var(--passive-color)' : 'var(--primary-color)',
              'background-color': branding.dark_mode_enabled ? 'var(--primary-color)' : 'var(--text-color)',
            }"
            class="qtyWrapper"
            tabindex="0"
            v-if="orderData && getTotalQuantity(item.item_id).totalQuantity"
            aria-label="Quantity wrapper"
          >
            <button
              :disabled="qtyLoading && selectedItemId == item.item_id"
              @click.stop="
                item.quantity != 1
                  ? changeQty('minus', item, index)
                  : removeItemClicked(item.order_item_id, item.item_name)
              "
              :style="{
                'border-color': qtyLoading ? 'var(--passive-color)' : 'var(--text-color)',
              }"
              v-if="!getTotalQuantity(item.item_id).multipleItems"
              aria-label="Decrease quantity"
              tabindex="0"
            >
              <template v-if="getTotalQuantity(item.item_id).totalQuantity != 1">-</template>
              <svg
                v-else
                class="delete"
                xmlns="http://www.w3.org/2000/svg"
                width="9.998"
                height="10.774"
                viewBox="0 0 9.998 10.774"
                tabindex="0"
              >
                <path
                  id="Delete_Solid"
                  d="M839.419,2646.771a.766.766,0,0,1-.767-.7l-.693-7.6c0-.025,0-.051,0-.076h-.574a.382.382,0,0,1,0-.764H839.9v-.866a.769.769,0,0,1,.768-.768h2.665a.769.769,0,0,1,.768.768v.866h2.518a.382.382,0,1,1,0,.764h-.574c0,.025,0,.051,0,.076l-.693,7.6a.766.766,0,0,1-.767.7Zm4.132-6.971a.379.379,0,0,0-.12.257l-.229,4.186a.382.382,0,0,0,.361.4h.021a.382.382,0,0,0,.381-.361l.229-4.186a.382.382,0,0,0-.36-.4h-.02a.381.381,0,0,0-.262.1Zm-1.933.278v4.186a.382.382,0,1,0,.764,0v-4.186a.382.382,0,1,0-.764,0Zm-1.451-.381a.382.382,0,0,0-.36.4l.229,4.186a.382.382,0,0,0,.381.361h.021a.382.382,0,0,0,.36-.4l-.229-4.186a.382.382,0,0,0-.382-.361Z"
                  transform="translate(-837.003 -2635.997)"
                />
              </svg>
            </button>
            <div class="qty">
              <div v-if="qtyLoading && selectedItemId == item.item_id" class="loader smallLoader"></div>
              <span tabindex="0" v-else>{{ getTotalQuantity(item.item_id).totalQuantity }}</span>
            </div>
            <button
              :disabled="qtyLoading && selectedItemId == item.item_id"
              @click.stop="changeQty('plus', item, index)"
              :style="{
                'border-color': qtyLoading ? 'var(--passive-color)' : 'var(--text-color)',
              }"
              v-if="!getTotalQuantity(item.item_id).multipleItems"
              aria-label="Increase quantity"
              tabindex="0"
            >
              +
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import formattingMixins from '@/mixins/formattingMixins'
import allergensMixins from '@/mixins/allergensMixins'
import menuItemImageVisibility from '@/mixins/menuItemImageVisibility'
import ItemAllergenModal from '@/components/Modals/FilterModals/ItemAllergenModal.vue'

import { mapState } from 'vuex'

export default {
  data() {
    return {
      imagePositionTop: null,
      imagePositionLeft: null,
      quickAddLoading: false,
      quickAddButtonTop: null,
      quickAddButtonLeft: null,
      windowWidth: window.innerWidth,
      ItemAllergenModalIsOpen: false,
      pendingItem: null,
    }
  },
  components: {
    ItemAllergenModal,
  },
  props: [
    'item',
    'category',
    'index',
    'orderData',
    'qtyLoading',
    'selectedItemId',
    'quickAddLoadingItemId',
    'fillScreenAnimation',
    'fillScreenItemId',
    'flyToCardItemId',
  ],
  mixins: [formattingMixins, allergensMixins, menuItemImageVisibility],
  computed: {
    ...mapState(['storeConfig', 'branding', 'cartButtonTop', 'cartButtonLeft']),
    checkIfPriceIsVisible() {
      if ('hide_price_if_zero' in this.branding?.display_options) {
        if (this.branding?.display_options?.hide_price_if_zero && this.getTheLowestPrice(this.item.variants) === 0) {
          return false
        }
      }
      return true
    },
    selectedAllergens() {
      return this.$store.state.selectedAllergens
    },
    selectedItemClasses() {
      return this.$store.state.selectedItemClasses
    },
    allergenIds() {
      if (this.item?.allergen_ids && this.selectedAllergens) {
        let allergenIds = this.item?.allergen_ids
        return this.getAllergyIconsFilter(allergenIds.filter((id) => this.selectedAllergens.includes(id)))
      } else return []
    },
    itemClassIds() {
      if (this.item?.class_ids && this.selectedItemClasses) {
        let itemClassIds = this.item?.class_ids
        return this.getClassIconsFilter(itemClassIds.filter((id) => this.selectedItemClasses.includes(id)))
      } else return []
    },
  },
  methods: {
    getTheLowestPrice(prices) {
      return prices[0]?.display_price
    },
    getTotalQuantity(itemId) {
      let totalQuantity = 0
      let multipleItems = false

      for (let i = 0; i < this.orderData.order.items.length; i++) {
        const item = this.orderData.order.items[i]

        if (item.item_id === itemId) {
          totalQuantity += item.quantity

          if (totalQuantity > item.quantity) {
            multipleItems = true
          }
        }
      }
      return {
        totalQuantity,
        multipleItems,
      }
    },
    getItemData(item, category, action, type) {
      this.quickAddLoading = true
      if (!this.branding.display_options.hide_menu_item_images) {
        this.imagePositionTop = this.$refs.itemImageWrapper.getBoundingClientRect().y + 'px'
        this.imagePositionLeft = this.$refs.itemImageWrapper.getBoundingClientRect().x + 'px'
        this.quickAddButtonTop = this.$refs.quickAddButton.getBoundingClientRect().y + 'px'
        this.quickAddButtonLeft = this.$refs.quickAddButton.getBoundingClientRect().x + 'px'
      }
      if (this.allergenIds.length > 0 || this.itemClassIds.length > 0) {
        this.toggleItemAllergenModal()
        this.pendingItem = { item, category, action, type }
      } else {
        this.$emit('getItemData', item, category, action, type)
      }
    },

    handleAddToCart() {
      if (this.pendingItem) {
        const { item, category, action, type } = this.pendingItem
        this.$emit('getItemData', item, category, action, type)
        this.pendingItem = null
        this.toggleItemAllergenModal()
      }
    },
    changeQty(action, item, index) {
      this.$emit('changeQty', action, item, index)
    },
    getUniqueAllergyIcons() {
      const uniqueAllergenIds = [...new Set(this.item.allergen_ids)]
      const uniqueClassIds = [...new Set(this.item.class_ids)]
      return this.getAllergyIcons(uniqueAllergenIds, uniqueClassIds)
    },
    toggleItemAllergenModal() {
      this.ItemAllergenModalIsOpen = !this.ItemAllergenModalIsOpen
    },
  },
  mounted() {
    // add event listener for window resize
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
  beforeUnmount() {
    // remove event listener for window resize
    window.removeEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
  },
}
</script>

<style src="../../../assets/css/Main/Menu/ItemCell.css" scoped>
@keyframes flyToCart {
  0% {
    top: v-bind(imagePositionTop);
    left: v-bind(imagePositionLeft);
    width: 300px;
  }
  75% {
    opacity: 1;
  }
  100% {
    top: calc(v-bind(cartButtonTop) + 20px);
    left: calc(v-bind(cartButtonLeft) + 20px);
    width: 0px;
    opacity: 0;
  }
}

@media screen and (min-width: 500px) {
  .fillScreen {
    position: fixed;
    top: v-bind(quickAddButtonTop);
    left: v-bind(quickAddButtonLeft);
    opacity: 0;
    z-index: 999;
    animation-name: fillScreen;
    animation-duration: 0.6s;
    animation-timing-function: linear;
    -webkit-animation-timing-function: linear;
  }

  @keyframes fillScreen {
    0% {
      scale: 1;
      opacity: 1;
    }
    60% {
      opacity: 1;
    }
    90% {
      scale: 100;
    }
    100% {
      opacity: 0;
    }
  }
}

@media screen and (max-width: 500px) {
  .fillScreen {
    position: fixed;
    top: v-bind(quickAddButtonTop);
    left: v-bind(quickAddButtonLeft);
    opacity: 0;
    z-index: 999;
    animation-name: fillScreen;
    animation-duration: 0.5s;
    animation-timing-function: linear;
    -webkit-animation-timing-function: linear;
  }

  @keyframes fillScreen {
    0% {
      scale: 1;
      opacity: 1;
    }
    60% {
      opacity: 1;
    }
    90% {
      scale: 70;
    }
    100% {
      opacity: 0;
    }
  }
}
</style>
